<div v-if="shouldRenderConfig && showButton" v-bind:class="getClassName">
    <button v-if="getIsMobile && !getIsSummaryFooterExpanded" type="button" class="btn btn-primary" v-on:click="quotationButton">
        <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/share.png'"/>
    </button> 
    <button v-else type="button" class="btn btn-primary" v-on:click="quotationButton">
        <img :class="getClassName + 'Icon'" :src="this.getBaseUrl + '/images/matrix/share.png'"/>
        <span>{{ $t(name) }}</span>
    </button>
</div>

